import { IApplicationState } from '../../../../types/types';
import { isKanbanchiUser } from 'app/store/model/authUser/selectors/isKanbanchiUser';

export const isShowChat = (
    state: IApplicationState
): boolean => {
    return isKanbanchiUser(state);
};
